export default __webpack_public_path__ + "static/media/m88-laliga-logo_EN.48e13501.svg";